/**
 * Utility functions for text formatting
 */

/**
 * Capitalizes the first letter of a string while making the rest lowercase
 * @param text - The text to capitalize
 * @returns The capitalized text
 */
export const capitalizeFirstLetter = (text: string): string => {
  if (!text) return text;
  return text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();
};

/**
 * Capitalizes the first letter of each word in a string
 * @param text - The text to capitalize
 * @returns The title-cased text
 */
export const toTitleCase = (text: string): string => {
  if (!text) return text;
  return text
    .split(' ')
    .map(word => capitalizeFirstLetter(word))
    .join(' ');
};
